import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import routes from './routes';
import { publicPath } from '@/config';

const router = createRouter({
    base: publicPath,
    history: createWebHistory(publicPath),
    routes
});

router.beforeEach(async (routeTo, routeFrom, next) => {
    const authRequired = routeTo.matched.some(route => route.meta.authRequired);
    const guestOnly = routeTo.matched.some(route => route.meta.guestOnly);
    const rolesMatchedRoute = routeTo.matched.find(route => route.meta.roles);
    const excludedEnvironmentsRoute = routeTo.matched.find(route => route.meta.excludedEnvironments);

    const { getters } = store;

    if (authRequired && !getters['auth/isLoggedIn']) {
        try {
            await store.dispatch('auth/takeToken');
        } catch {
            // no server session - fall through to the login redirect below
        }
    }

    if (
        getters['auth/isLoggedIn'] &&
        getters['auth/isMcpUser'] &&
        !['how_to', 'mcp_access', 'logout'].includes(routeTo.name)
    ) {
        return next({ name: 'mcp_access' });
    }

    const excludedEnvironments = excludedEnvironmentsRoute?.meta.excludedEnvironments;
    const currentEnvironment = getters['environments/current'];

    if (excludedEnvironments?.length && excludedEnvironments.includes(currentEnvironment)) {
        return redirectToDashboard();
    }

    if (!authRequired && !guestOnly) {
        return next();
    }

    const isLoggedIn = getters['auth/isLoggedIn'];

    if (authRequired) {
        if (isLoggedIn) {
            const roles = rolesMatchedRoute?.meta.roles;

            if (!roles?.length) {
                return next();
            }

            const loggedUserRole = getters['auth/loggedUserRole'];

            return roles.includes(loggedUserRole) ? next() : redirectToDashboard();
        }

        return redirectToLogin();
    }

    if (guestOnly) {
        return isLoggedIn ? redirectToDashboard() : next();
    }

    function redirectToLogin() {
        next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
    }

    function redirectToDashboard() {
        next({ name: 'dashboard' });
    }
});

const DEFAULT_TITLE = 'Affogata';

router.afterEach(to => {
    if (!['dashboard', 'helper'].includes(to.name)) {
        document.title = `${to?.meta?.title || ''} | ${DEFAULT_TITLE}` || DEFAULT_TITLE;
    }

    if (window.analytics) {
        window.analytics.page(to?.meta?.title || to.name || '');
    }
});

export default router;
